import styled from '@emotion/styled';

export const fontStyle = {
  fontFamily: "'Roboto', sans-serif !important",
};

export const pageTileStyle = {
  fontSize: '22px',
  padding: 0,
};

export const sectionHeaderStyle = {
  fontSize: '18px',
  margin: '0 0 10px 0',
};

export const fieldRowStyle = {
  fontSize: '15px',
  lineHeight: '20px',
  whiteSpace: 'pre-line',
};

export const lineBreakStyle = {
  whiteSpace: 'pre',
};

// Styled components for SummaryNote
export const PageTitle = styled('h2')`
  font-size: 22px;
  padding: 0;
`;

export const SectionHeader = styled('h3')`
  font-size: 18px;
  margin: 0 0 10px 0;
`;

export const FieldRow = styled('div')`
  font-size: 15px;
  line-height: 20px;
  white-space: pre-line;
  margin-bottom: ${(props) => props.marginBottom || '10px'};
`;

export const LineBreak = styled('div')`
  white-space: pre;
`;

export const SectionContainer = styled('div')`
  margin-bottom: ${(props) => props.marginBottom || '15px'};
`;

